export default {
  "title": {
    "evolution": "Evolução da fadiga",
    "biocompatibilityIndex": "Índice de biocompatibilidade",
    "indicators": "Principais indicadores",
    "workshifts": "Viagens",
    "alertCurve": "Curva de alerta"
  },
  "help": {
    "workshifts": "Permite visualizar os dias registrados no intervalo de datas selecionado na parte superior da tela (serão exibidos apenas no máximo 14 dias), os dias podem ser compostos por diferentes tipos de atividades descritas na legenda deste gráfico.",
    "alertCurve": "Permite visualizar os diferentes níveis de alerta, fadiga e sonolência durante o período de datas selecionado na parte superior da tela (apenas um máximo de 14 dias será exibido). Através deste relatório poderá identificar os momentos de exposição à sonolência e fadiga crítica.",
    "events": "Evento de Sonolência: O motorista apresenta sinais de fadiga ou sonolência. Eles estão em um estado em que a fadiga tem um efeito adverso em sua capacidade de concentrar-se na tarefa de dirigir."
  },
  "buttons": {
    "moreDetails": "mais detalhes",
    "changeView": "alterar visualização"
  },
  "graphToolTip": {
    "indice": "índice de fadiga",
    "activity": "Atividade",
    "alertLevel": "Nivel de alerta",
    "event": "Evento",
    "hour": "Hora",
    "duration": "Duração",
    "start": "Inicio",
    "end": "Fim",
    "place": "Lugar"
  },
  "graphEventsLabels": {
    "driving": "Condução",
    "detention": "Detenção",
    "base": "Base",
    "client": "Cliente"
  },
  "graphAlertStateLabels": {
    "a1": "Totalmente acordado",
    "a2": "Acordado",
    "a3": "Normal",
    "a4": "Sonolência leve",
    "a5": "Sonolência",
    "a6": "Muito cansado",
    "a7": "Extremamente cansado",
    "aSleep": "Dormindo",
    "roadWarning": "Sonolência",
    "sleepPeriods": "Períodos de sono",
    "featuredSleepPeriods": "Períodos de sono em destaque",
    "day": "DIA",
    "analysis": "ANÁLISE",
    "hours": "HORAS",
    "events": "EVENTOS"
  },
  "ibcToolTip": {
    "labelText": "Indicador que permite identificar quão arriscada é a estrutura de turno do motorista. Para isso, são processados os horários de início e término de trabalho dos últimos 14 dias e é entregue esse índice, que varia entre 0 e 100, sendo 0 não fatigado e 100 extremamente fatigado.",
    "outOfRisk": "Baixo risco",
    "middleRisk": "Risco médio",
    "to": "a",
    "higherRisk": "Alto risco"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/fatigue/driverFatigue.js